<template>
	<EventLayout :event="event" :subtitle="subtitle">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="showModal('create-stage-modal')">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</PrimaryButton>
		</template>
		<Modal id="create-stage-modal">
			<template #title>{{ trans('events.stages.create') }}</template>
			<div class="flex items-end">
				<Switch v-model="form.active" label="events.stages.active"/>
			</div>
			<div class="grid grid-cols-2 gap-3">
				<LabeledObject class="col-span-2" required>
					<template #label>{{ trans('general.title') }}</template>
					<input v-model="form.title" type="text">
				</LabeledObject>
				<LabeledObject required>
					<template #label>{{ trans('events.stages.begins_at') }}</template>
					<IconDateTimeInput v-model="form.begins_at" icon-class="fa-solid fa-hourglass-start" full/>
				</LabeledObject>
				<LabeledObject required>
					<template #label>{{ trans('events.stages.ends_at') }}</template>
					<IconDateTimeInput v-model="form.ends_at" icon-class="fa-solid fa-hourglass-end" full/>
				</LabeledObject>
			</div>
			<template #footer>
				<PrimaryButton :color="Color.Green" @click.stop="emit('store', form)">
					<i class="fa-solid fa-check mr-2"/>
					{{ trans('general.confirm') }}
				</PrimaryButton>
			</template>
		</Modal>
		<slot/>
	</EventLayout>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {showModal} from '@/Helpers/general'
import {defineEmits, defineProps} from 'vue'
import {type Event} from '@/Types/Events/Event'
import EventLayout from '@/Layouts/EventLayout.vue'
import Modal from '@/Components/UI/Modals/Modal.vue'
import {type Stage} from '@/Types/Events/Stages/Stage'
import Switch from '@/Components/UI/Switches/Switch.vue'
import {type InertiaForm, useForm} from '@inertiajs/vue3'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import IconDateTimeInput from '@/Components/UI/Inputs/IconDateTimeInput.vue'

defineProps<{
	event:Event,
	subtitle:string,
}>()

const emit = defineEmits([
	'store',
])

const form:InertiaForm<Stage> = useForm<Stage>({
	title: '',
	begins_at: '',
	ends_at: '',
	active: false,
} as Stage)
</script>